import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-redirect',
	path: '/jira/servicedesk/projects/:projectKey/settings',
};
